import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicInput } from 'core/components';
import { translate } from 'core/utils';

const AdjustAllSkusTemplate = ({ modalParams, modalParams: { data: { form, adjustAllSkus } } }) => {
	return (
		<section>
			<form className="form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{translate('INVENTORYSYNC.ADJUST.ADJUSTALLSKUS')}</h3>
				</div>

				<div className="ReactModal__body">
					<p className="message message--default spc--bottom--sml">{translate('INVENTORYSYNC.ADJUST.MESSAGE')}</p>
					<BaasicInput field={form.$('note')} autoFocus />
				</div>

				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--bottom--sml spc--right--sml" onClick={adjustAllSkus}>
						{translate('INVENTORYSYNC.ADJUST.BUTTON')}
					</button>
					<button
						className="btn btn--med btn--outline spc--bottom--sml"
						onClick={modalParams.close}
					>
						{translate('CANCEL')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(AdjustAllSkusTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product-inventory/pages/AdjustAllSkusTemplate.jsx